import { logErrorToFirebase } from "../firebase/firebaseAnalytics";

// Global error handler for JavaScript errors
window.onerror = function (message, source, lineno, colno, error) {
    logErrorToFirebase("app_error", message, {
        source,
        lineno,
        colno,
        error: error ? error.toString() : "Unknown error",
    });
};

// Capture unhandled promise rejections
window.onunhandledrejection = function (event) {
    logErrorToFirebase("promise_rejection", event.reason.toString(), {});
};
